import clsx from "clsx";

import { ButtonGenericProps } from "./button-generic-props";

export interface GetButtonClassNameArgs
  extends Pick<ButtonGenericProps, "variant" | "size" | "fullWidth"> {
  disabled?: boolean;
  customClassName?: string;
}

export const getButtonClassName = ({
  variant,
  size,
  fullWidth,
  disabled,
  customClassName,
}: GetButtonClassNameArgs) =>
  clsx(
    "rounded-lg transition-all whitespace-nowrap",
    variant === "neutral" && "bg-black text-white",
    variant === "neutral-outline" && "text-black",
    variant === "neutral-light" && "bg-neutral-light text-black hover:bg-white hover:text-primary",
    variant === "primary" && "bg-primary text-white hover:bg-black",
    variant === "primary-light" && "bg-primary text-white hover:bg-white hover:text-primary",
    variant === "primary-inverted" && "bg-white text-primary hover:bg-primary hover:text-white",
    variant === "primary-outline" && "bg-transparent border border-primary text-primary",
    variant === "light" && "bg-white text-primary hover:bg-black hover:text-white",
    variant === "light-outline" && "bg-transparent border border-white text-white",
    variant === "neutral-outline" && "bg-transparent border border-black text-black",
    size === "lg" && "px-10 h-[75px] text-xl font-medium hover:rounded-4xl",
    size === "md" && "px-10 h-12 md:px-12 md:h-14 md:text-xl font-medium hover:rounded-[30px]",
    size === "sm" && "px-4 h-10 md:px-6 text-sm hover:rounded-[20px]",
    fullWidth && "w-full",
    disabled && "pointer-events-none opacity-75",
    customClassName
  );
